export const initShop = () => {
    const modal = document.getElementById('heritage-quote-modal');
    if (!modal) return;

    const overlay = modal.querySelector('.heritage-quote-modal-overlay');
    const closeBtn = modal.querySelector('.heritage-quote-modal-close');
    const productNamePlaceholder = modal.querySelector('.heritage-quote-product-name');

    const openModal = (productName) => {
        if (productNamePlaceholder) {
            productNamePlaceholder.textContent = productName;
        }
        modal.classList.add('is-active');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    };

    const closeModal = () => {
        modal.classList.remove('is-active');
        document.body.style.overflow = '';
    };

    // Listen for clicks on Get A Quote buttons
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.heritage-btn-get-quote, .js-get-quote');
        if (trigger) {
            e.preventDefault();
            const productName = trigger.getAttribute('data-product-title') || 'General Inquiry';
            openModal(productName);
        }
    });

    // Close listeners
    if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
    }
    
    if (overlay) {
        overlay.addEventListener('click', closeModal);
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-active')) {
            closeModal();
        }
    });

    // Initialize AJAX category filters
    initAjaxFilters();

    // Initialize Sticky Filter
    initStickyFilter();
};

const initStickyFilter = () => {
    const filterContainer = document.querySelector('.heritage-sticky-filter-container');
    const productsGrid = document.querySelector('.heritage-products-grid');

    if (filterContainer) {
        window.addEventListener('scroll', () => {
            // Show after scrolling past the top of the grid or a fallback threshold
            const scrollThreshold = productsGrid ? (productsGrid.offsetTop - 100) : 300;
            if (window.scrollY > scrollThreshold) {
                filterContainer.style.opacity = '1';
                filterContainer.style.pointerEvents = 'auto';
            } else {
                filterContainer.style.opacity = '0';
                filterContainer.style.pointerEvents = 'none';
            }
        });
        
        // Close offcanvas when a tab is clicked inside the menu
        const menuTabs = document.querySelectorAll('#categoryFilterOffcanvas .heritage-cat-tab');
        const closeBtn = document.querySelector('#categoryFilterOffcanvas [data-bs-dismiss="offcanvas"]');
        
        menuTabs.forEach(tab => {
            tab.addEventListener('click', () => {
                if (closeBtn) closeBtn.click();
            });
        });
    }
};

const initAjaxFilters = () => {
    const tabs = document.querySelectorAll('.heritage-cat-tab');
    if (!tabs.length) return;

    // Helper to fetch and render products
    const fetchProducts = async (categoryId, paged = 1) => {
        const productsGrid = document.querySelector('.heritage-products-grid');
        if (productsGrid) {
            productsGrid.classList.add('is-loading');
        }

        try {
            const formData = new FormData();
            formData.append('action', 'heritage_filter_products');
            formData.append('category_id', categoryId);
            formData.append('paged', paged);
            formData.append('nonce', window.heritage_shop_ajax.nonce);

            const response = await fetch(window.heritage_shop_ajax.ajax_url, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                const tabsContainer = document.querySelector('.heritage-category-tabs-container');
                
                // Remove existing products and pagination
                document.querySelectorAll('.heritage-products-grid, .woocommerce-pagination, .woocommerce-info').forEach(el => el.remove());

                // Insert new HTML below the tabs
                if (tabsContainer) {
                    tabsContainer.insertAdjacentHTML('afterend', data.data.html);
                }
            }
        } catch (error) {
            console.error('AJAX Filter Error:', error);
        } finally {
            const newGrid = document.querySelector('.heritage-products-grid');
            if (newGrid) {
                newGrid.classList.remove('is-loading');
            }
        }
    };

    // Scroll helper
    const scrollToTabs = () => {
        const tabsContainer = document.querySelector('.heritage-category-tabs-container');
        if (tabsContainer) {
            const tabsTop = tabsContainer.getBoundingClientRect().top + window.scrollY;
            if (window.scrollY > tabsTop) {
                window.scrollTo({
                    top: tabsTop - 100, // 100px offset for sticky header
                    behavior: 'smooth'
                });
            }
        }
    };

    // Tab click event
    tabs.forEach(tab => {
        tab.addEventListener('click', async (e) => {
            e.preventDefault();

            const categoryId = tab.getAttribute('data-category-id');
            
            // Update active state for all tab instances (top and offcanvas)
            tabs.forEach(t => {
                t.classList.remove('active');
                if (t.getAttribute('data-category-id') === categoryId) {
                    t.classList.add('active');
                }
            });

            scrollToTabs();
            await fetchProducts(categoryId, 1);
        });
    });

    // Pagination click event (using event delegation since pagination is injected dynamically)
    document.addEventListener('click', async (e) => {
        const pageLink = e.target.closest('.woocommerce-pagination a.page-numbers');
        if (pageLink) {
            e.preventDefault();
            
            let paged = 1;
            const href = pageLink.getAttribute('href');
            
            // Parse page number from standard '?paged=2' or fallback to extracting numbers
            const match = href.match(/paged=(\d+)/);
            if (match && match[1]) {
                paged = parseInt(match[1], 10);
            } else {
                // If permalinks are pretty (e.g. /page/2/), extract the number from text or href
                const pageText = pageLink.textContent.trim();
                if (!isNaN(pageText)) {
                    paged = parseInt(pageText, 10);
                } else if (pageLink.classList.contains('next')) {
                    const current = document.querySelector('.woocommerce-pagination .current');
                    paged = current ? parseInt(current.textContent.trim(), 10) + 1 : 2;
                } else if (pageLink.classList.contains('prev')) {
                    const current = document.querySelector('.woocommerce-pagination .current');
                    paged = current ? parseInt(current.textContent.trim(), 10) - 1 : 1;
                }
            }

            // Get active category ID
            const activeTab = document.querySelector('.heritage-cat-tab.active');
            const categoryId = activeTab ? activeTab.getAttribute('data-category-id') : 0;

            scrollToTabs();
            await fetchProducts(categoryId, paged);
        }
    });
};
